//WE.Flow.Html.Contracts.Manifests.Components.WorkingContextManifest
import { ToolbarItemManifest } from "./ToolbarItemManifest";

export class WorkingContextManifest {
    id: string = "";
    name: string = "";
    toolbarItem: ToolbarItemManifest = null;
    defaultParameters: any = null;
    viewUrl: string = "";
    namespace: string = "";
    detailViewUrl: string = "";
    viewModelId: string = "";
    isWorkflow: boolean = false;
    isWorkingContext: boolean = false;
    reuseInstance: boolean = false;
    cssUrls: string[] = null;
    moduleRoles: string[] = null;
    notificationsViewUrl: string = "";
    resetsBreadcrumbs: boolean = false;
    tags: string[] = null;
}
